import React, {useState} from "react";
import {useSelector} from "react-redux";
import {ConfirmDialog} from "primereact/confirmdialog";
import {TabPanel, TabView} from "primereact/tabview";
import PageHeaderButton from "../components/page-header-button";
import {hasAdminPermission, hasSalesAccess} from "../../system/admin-access";
import {useTranslate} from "../../system/useTranslate";
import AdminAccessDenied from "../../system/components/admin-access-denied";
import MarkdownHelp from "../../system/components/markdown-help";
import BillingDashboardTab from "./tabs/billing-dashboard-tab";
import PlansPricingTab from "./tabs/plans-pricing-tab";
import DiscountsTab from "./tabs/discounts-tab";
import ReferralsTab from "./tabs/referrals-tab";
import PurchasesDomainTab from "./tabs/purchases-domain-tab";
import SubscriptionsDomainTab from "./tabs/subscriptions-domain-tab";
import PaymentSettingsTab from "./tabs/payment-settings-tab";

const tabs = [
    {permission: "sales.tab.dashboard", labelKey: "billing-admin-tab-dashboard", helpKey: "sales-tab-dashboard-help", icon: "pi pi-chart-line", component: BillingDashboardTab},
    {permission: "sales.tab.plans", labelKey: "billing-admin-tab-plans", helpKey: "sales-tab-plans-help", icon: "pi pi-box", component: PlansPricingTab},
    {permission: "sales.tab.subscriptions", labelKey: "billing-admin-tab-subscriptions", helpKey: "sales-tab-subscriptions-help", icon: "pi pi-id-card", component: SubscriptionsDomainTab},
    {permission: "sales.tab.purchases", labelKey: "billing-admin-tab-purchases", helpKey: "sales-tab-purchases-help", icon: "pi pi-shopping-cart", component: PurchasesDomainTab},
    {permission: "sales.tab.discounts", labelKey: "billing-admin-tab-discounts", helpKey: "sales-tab-discounts-help", icon: "pi pi-ticket", component: DiscountsTab},
    {permission: "sales.tab.referrals", labelKey: "billing-admin-tab-referrals", helpKey: "sales-tab-referrals-help", icon: "pi pi-share-alt", component: ReferralsTab},
    {permission: "sales.tab.payment-settings", labelKey: "billing-admin-tab-payment-settings", helpKey: "sales-tab-payment-settings-help", icon: "pi pi-cog", component: PaymentSettingsTab},
];

function Sales() {
    const translate = useTranslate();
    const {user} = useSelector((state) => state.auth);
    const [activeIndex, setActiveIndex] = useState(0);
    const visibleTabs = tabs.filter((tab) => hasAdminPermission(user, tab.permission));

    if (!hasSalesAccess(user)) {
        return <AdminAccessDenied
            titleKey="sales-access-denied-title"
            descriptionKey="sales-access-denied-description"
        />;
    }

    if (!visibleTabs.length) return <AdminAccessDenied/>;

    return (
        <div className="w-full p-3 flex flex-column gap-3 rtl text-xs">
            <ConfirmDialog/>
            <PageHeaderButton
                title="sales-hero-title"
                description="sales-hero-description"
            />

            <TabView
                activeIndex={activeIndex}
                onTabChange={(event) => setActiveIndex(event.index)}
                className="rtl text-xs"
                pt={{
                    nav: {className: "rtl flex-nowrap "},
                    panelContainer: {className: "p-3 border-1 border-200 border-round-bottom-xl"},
                }}
            >
                {visibleTabs.map((tab, index) => {
                    const ActiveComponent = tab.component;
                    return (
                        <TabPanel
                            key={tab.labelKey}
                            header={translate(tab.labelKey)}
                            leftIcon={`${tab.icon} ml-2`}
                            pt={{headerAction: {className: "text-xs white-space-nowrap"}}}
                        >
                            {activeIndex === index && <>
                                <ActiveComponent/>
                                <MarkdownHelp contentKey={tab.helpKey}/>
                            </>}
                        </TabPanel>
                    );
                })}
            </TabView>
        </div>
    );
}

export default Sales;
